var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.d_showResults)?[_c('polestar-result',{attrs:{"p_selectedWdm72Results":_vm.d_selectedWdm72Results,"d_selectedWdm72Key":_vm.d_selectedWdm72Key,"column_list":_vm.column_list,"p_selectedProjectData":_vm.d_selectedProjectData}})]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }